
import { Options, prop, Vue } from "vue-class-component";
import OverlayPanel from "primevue/overlaypanel";
import { LogProsesScan } from "@/domain/entities/BookingV4";
import { formatDate } from "@/app/infrastructures/misc/Utils";
import moment from "moment";

class Props {
  entries = prop<LogProsesScan[]>({
    default: () => [],
    type: Array
  });
}

@Options({
  components: {
    OverlayPanel
  },
  watch: {
    visibleToastHistorySuccessBooking(val: boolean) {
      if (val) {
        this.onHideToastHistorySuccessBooking();
      }
    }
  }
})
class LogProcessScanPanel extends Vue.with(Props) {
  openTable(event: Event) {
    const refsLogProcessScanPanel: any = this.$refs?.["log-process-scan-panel"];
    refsLogProcessScanPanel?.toggle(event);
  }
  hideTable() {
    const refsLogProcessScanPanel: any = this.$refs?.["log-process-scan-panel"];
    refsLogProcessScanPanel?.hide();
  }

  formatDate = formatDate;
}

export default LogProcessScanPanel;
